import { createFileRoute } from '@tanstack/react-router';
import UserLayout from '@components/layout/UserLayout.tsx';
import SupportPage from '@features/client/support/SupportPage.tsx';

export const Route = createFileRoute('/c/$orgId/$portalId/support/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <UserLayout>
      <SupportPage />
    </UserLayout>
  );
}
